import { render } from "./create-motion-modal.vue?vue&type=template&id=0a507efc"
import script from "./create-motion-modal.vue?vue&type=script&lang=js"
export * from "./create-motion-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__